import Lamp from './Lamp'
import ElTableAuto from './ElTableAuto'
import AutoTable from './AutoTable'
import AutoTableData from './AutoTableData'
import DragDialog from './DragDialog'
import DragSize from './DragSize'


const plugin = {
  install: function (Vue) {
    // 自定义全局组件
    Vue.component('lamp', Lamp)
    Vue.component('el-table-auto', ElTableAuto)
    Vue.component('auto-table', AutoTable)
    Vue.component('auto-table-data', AutoTableData)
    Vue.component('drag-dialog', DragDialog)
    Vue.component('drag-size', DragSize)
  }
}

export default plugin
